export default __webpack_public_path__ + "static/lframe-new-and-used-car-cc22cff13cd3a624554b16b74b432119.webp";